import { useState, useCallback } from "react";
import formatCurrency from "@/utils/formatCurrency";

const CurrencyInput = ({ value, onChange, className = "", placeholder = "0", disabled = false }) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = useCallback((e) => {
    const raw = e.target.value.replace(/[^0-9.]/g, '');
    const parts = raw.split('.');
    const sanitized = parts[0] + (parts.length > 1 ? '.' + parts.slice(1).join('') : '');
    onChange(parseFloat(sanitized) || 0);
  }, [onChange]);

  let displayValue = "";
  if (isFocused) {
    displayValue = value || "";
  } else if (value) {
    displayValue = `₹${formatCurrency(value)}`;
  }

  return (
    <input
      type="text"
      inputMode="decimal"
      className={className}
      value={displayValue}
      onChange={handleChange}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      placeholder={`₹${placeholder}`}
      disabled={disabled}
    />
  );
};

export default CurrencyInput;
